(function () {
    'use strict';

    angular
        .module('homeControllers')
        .controller('FeatureMyProfileController', Controller);

    Controller.$inject = ['$scope', 'supervisorService', 'employeeService', 'systemOwnerReviewService', 'accessReviewService', 'processAccessRequestService', 'selfAccessRequestService'];

    function Controller($scope, supervisorService, employeeService, systemOwnerReviewService, accessReviewService, processAccessRequestService, selfAccessRequestService) {

        var tasks = {};

        var identityName = $scope.authenticatedUser.IdentityName;

        // Get employee arrival requests to create
        employeeService
            .getNotProcessedEventsArrivalEmployees(identityName)
            .then(function (response) {
                tasks.notProcessedEventsArrivalEmployees = 0;
                //tasks.notProcessedEventsArrivalEmployees = response.length;
            });

        // Get request to authorize as supervisor
        supervisorService
            .getUserRequestsToAuthorize(identityName)
            .then(function (userRequestsToAuthorize) {
                tasks.supervisorAuthorize = userRequestsToAuthorize.length;
            });

        // Get pendings as system owner
        employeeService
            .getEmployeesWithPendingsBySystemOwner(identityName)
            .then(function (response) {
                tasks.systemOwnerAuthorize = response.NbEmployees;
            });

        // Get pendings as custodian
        processAccessRequestService
            .getNumberOfEmployeesWithPendingsByCustodian(identityName)
            .then(function (response) {
                tasks.custodianAuthorize = response.NbEmployees;
            });

        // Check if there are system owner review        
        systemOwnerReviewService
            .getStatusReview(identityName)
            .then(function (processStep) {
                $scope.withSystemOwnerReview = false;

                if (_.isUndefined(processStep) || _.isEmpty(processStep)) {
                    $scope.withSystemOwnerReview = false;
                }
                else {
                    $scope.withSystemOwnerReview = !processStep.IsComplete;
                }

                tasks.systemOwnerReview = $scope.withSystemOwnerReview === true ? 1 : 0;
            });

        // Check if there are supervisor review        
        accessReviewService
            .needAccessReview(identityName)
            .then(function (response) {
                tasks.supervisorReview = response.NeedAccessReview === true ? 1 : 0;
            });

        // Get employee Self Access Requests
        selfAccessRequestService
            .getSelfAccessRequestsWithoutOwnerForSupervisor()
            .then(function (response) {
                tasks.selfAccessRequestsWithoutOwnerForSupervisor = response.length;
               
            });

        // Tasks
        $scope.withTasks = function () {
            var sumTasks = 0
            for (var task in tasks) {
                var valTask = tasks[task];
                if (_.isUndefined(valTask)) continue;
                sumTasks = sumTasks + valTask;
            }
            return sumTasks;
        }

        $scope.nbTasks = function () {
            if (Object.keys(tasks).length !== 7) return;
            return $scope.withTasks();
        }
    }
})();